import { render, staticRenderFns } from "./SystemRoleEdit.vue?vue&type=template&id=a83d6b86&scoped=true&"
import script from "./SystemRoleEdit.vue?vue&type=script&lang=js&"
export * from "./SystemRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83d6b86",
  null
  
)

export default component.exports